module.exports = __webpack_public_path__ + "img/white-shape.442405c9.svg";